// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface VoteThumbsUpIconSignature {
  Element: SVGSVGElement;
}

export const VoteThumbsUpIcon: TOC<VoteThumbsUpIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M22.768 7.359C22.578 7.132 22.297 7 22 7H16V3C16 2.448 15.553 2 15 2H12C11.6 2 11.238 2.238 11.081 2.605L8.341 9H8C8 8.448 7.553 8 7 8H3C2.447 8 2 8.448 2 9V19C2 19.552 2.447 20 3 20H7C7.553 20 8 19.552 8 19V18.478L11.629 19.929C11.746 19.976 11.873 20 12 20H20C20.483 20 20.897 19.654 20.984 19.179L22.984 8.179C23.037 7.887 22.957 7.587 22.768 7.359ZM6 18H4V10H6V18ZM12.192 18H19.166L20.802 9H15C14.447 9 14 8.552 14 8V4H12.659L9.919 10.394C9.762 10.762 9.4 11 9 11H8V16.323L12.192 18Z"/>
</svg>
</template>;